<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}' style="max-height: 30px">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Главная</a></li>
        <li><a routerLink="/courses">Предетные тесты</a></li>
        <li>{{currentSubject}}</li>
      </ul>
      <h2>Предметные тесты</h2>
    </div>
  </div>
</div>

<section class="tests-area ptb-100">
  <div class="container">
    <div class="tests-topbar">
      <div class="row align-items-center">
        <div class="col-lg-4 col-md-4">
          <div class="topbar-result-count">
            <!--            <p>Showing 1 – 6 of 54</p>-->
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-4">
        <div *ngFor="let test of tests" class="single-tests-box mb-30">
          <div class="tests-image">
            <div class="tests-tag">
              <a class="d-block">{{test.title}}</a>
            </div>
          </div>

          <div class="tests-content">
            <h3><a class="d-inline-block">{{test.title}}</a></h3>
            <div class="tests-rating">
              <div class="review-stars-rated">
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
                <i class='bx bxs-star'></i>
              </div>
              <div class="rating-total">
                (5.0)
              </div>
            </div>
          </div>

          <div class="tests-box-footer">
            <ul>
              <li class="students-number">
                <i class='bx bx-book-open'></i> Язык: {{languagesMap[test.language]}}
              </li>
              <li class="tests-price">
                Цена: {{test.price}} сом
              </li>
            </ul>
            <div class="text-center tests-start">
              <button (click)="confirmStartTest(test)"
                      class="btn btn-outline-danger btn-rounded btn-md"
                      data-target="#pract"
                      data-toggle="modal">Начать
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="pagination-area text-center">
          <span aria-current="page" class="page-numbers current">1</span>
          <a class="page-numbers">2</a>
          <a class="page-numbers">3</a>
          <a class="page-numbers">4</a>
          <a class="page-numbers">5</a>
          <a class="next page-numbers"><i class='bx bx-chevron-right'></i></a>
        </div>
      </div>
    </div>
  </div>
</section>

<div aria-labelledby="myModalLabel" class="modal fade text-selection-none"
     id="pract" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">{{selectedTest.title}}</h4>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <span aria-hidden="true" style="font-size: 45px; font-weight: 300;"> &times;
          </span>
        </button>
      </div>
      <div class="modal-body">
        <p>Тест состоит из 30 заданий и на его выполнение отводится 60 минут. После нажатия на кнопку (Начать тест)
          автоматически начинается отсчёт времени. По окончании времени вы не сможете продолжить тест. Во время
          выполнения заданий Вы можете изменить выбранный вариант ответа, но сделать это можно только один раз, для
          каждого задания. При исправлении, вторичный ответ будет обозначен квадратиком. После прохождения теста, Вы
          сможете в личном кабинете увидеть результат, в котором будет показано количество данных Вами правильных
          ответов и общий процент правильно и неправильно выполненных заданий.</p>
        <h6>Желаем удачи!</h6>

      </div>
      <div class="modal-footer">
        <div class="buttons">
          <button (click)="startTest()" class="btn btn-danger btn-rounded btn-md" data-dismiss="modal"
                  type="button">Начать
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
